import { IonApp, IonButton, IonCol, IonRouterOutlet, IonRow, IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';

import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule, provideAppInitializer, ApplicationConfig, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GlobalHttpInterceptorService } from './services/auth-service/global-http-interceptor-service ';
import { mainMenuModule } from 'src/environments/environment-layout';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { WhatsAppModule } from './api/proxy/whatsapp/whats-app.module';

import { Router } from '@angular/router';
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";

// Conditionally import E2E mock providers
// Import the function - it will only be called if E2E_TEST_MODE is true
let getE2EMockProviders: (() => any[]) | null = null;
if (environment.E2E_TEST_MODE === true) {
  // Use a function that imports at runtime
  // This avoids compilation errors when E2E_TEST_MODE is false
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const mockProvidersModule = require('./e2e-mock-providers');
    getE2EMockProviders = mockProvidersModule.getE2EMockProviders;
  } catch (error) {
    console.warn('E2E_TEST_MODE enabled but mock providers not found:', error);
  }
}

// Build providers array
const providers: any[] = [
  provideIonicAngular({
      rippleEffect: false,
      mode: 'md',           
      inputShims: true,
      scrollPadding: true,
      hideCaretOnScroll: true,
      scrollAssist: true           
  }),
  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true },
  provideHttpClient(withXhr(), withInterceptorsFromDi()),

  {
    provide: ErrorHandler,
    useValue: SentryAngular.createErrorHandler({
      // Only capture errors and exceptions, no performance monitoring
      showDialog: false,
    }),
  },
  // TraceService removed - performance monitoring disabled to reduce Sentry quota usage
  // Only error/exception logging is enabled
];

// Add E2E mock providers if in test mode
if (getE2EMockProviders) {
  providers.push(...getE2EMockProviders());
}

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
    IonApp, IonButton, IonCol, IonRow, IonRouterOutlet,
BrowserModule,
        CommonModule,

        AppRoutingModule,
        mainMenuModule,
        SharedModule,
        WhatsAppModule.forRoot({ rootUrl: '' })],
    providers: [
        ...providers,
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: './assets/i18n/',
                suffix: '.json'
            })
        })
    ]
})
export class AppModule {
    constructor() {

    }
}

 